import { render, staticRenderFns } from "./_TableHeader.vue?vue&type=template&id=1ab3efcf&scoped=true&"
import script from "./_TableHeader.vue?vue&type=script&lang=ts&"
export * from "./_TableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./_TableHeader.vue?vue&type=style&index=0&id=1ab3efcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3efcf",
  null
  
)

component.options.__file = "_TableHeader.vue"
export default component.exports